import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import NoShortlistIllustration from "PFTheme/graphics/illustrations/illustration-no-shortlist.svg";
import { useTranslation } from "react-i18next";

import css from "./no_shortlists_placeholder.module.scss";

export const NoShortlistsPlaceholder = () => {
  const { t } = useTranslation("activities", { keyPrefix: "resourceTableToggle.shortlists" });

  return (
    <Stack center gap="spacingLg" className={css.root}>
      <NoShortlistIllustration className={css.icon} />
      <Typography variant="h5">{t("noShortlistedCandidates")}</Typography>
    </Stack>
  );
};
